export class BroadcastMessage {
    type: string;
    payload?: any;
}

export enum BroadcastTypes {
    LOGIN = 'login',
    LOGOUT = 'logout',
    ERROR = 'error',
}
